import { Link } from 'react-router-dom';
import { useSetting, formatDeadline } from '@/hooks/useSetting';

export default function CTASection() {
  const deadlineRaw = useSetting('registration_deadline', '');
  const displayDeadline = deadlineRaw ? formatDeadline(deadlineRaw) : 'September 1, 2026';

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20medical%20laboratory%20abstract%20background%20with%20soft%20blue%20and%20teal%20gradients%2C%20geometric%20hexagon%20patterns%2C%20clean%20clinical%20aesthetic%2C%20digital%20healthcare%20concept%2C%20bright%20and%20inspiring%20atmosphere%2C%20no%20people%20or%20text&width=1600&height=800&seq=medihack-cta-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 to-primary-900/80"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
          Ready to Make an Impact?
        </h2>
        <p className="text-white/70 text-base md:text-lg max-w-xl mx-auto mb-8">
          Gather your team, pick a challenge, and build something that could change healthcare forever. Registration closes {displayDeadline}.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/register"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-accent-500 hover:bg-accent-600 text-background-50 dark:text-foreground-950 font-semibold text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Register Your Team Now
          </Link>
          <a
            href="#contact"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/30 hover:border-white/60 text-white font-medium text-base transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Contact Organizers
          </a>
        </div>
      </div>
    </section>
  );
}